import { useCallback } from 'react'
import * as React from 'react'
import styled from 'styled-components'

import OverlappingTimesModal from './OverlappingTimesModal'

import SolidExclamationTriangleIcon from 'LuxKit/Icons/solid/SolidExclamationTriangleIcon'
import Tooltip from 'LuxKit/Tooltip'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import type { TripItem } from 'tripPlanner/types/tripItem'
import Clickable from 'components/Common/Clickable'

const FlexClickable = styled(Clickable)`
  display: flex;
`

interface Props {
  item: TripItem
  changeItemDates: () => void
  previousItem: TripItem | undefined
  nextItem: TripItem | undefined
}

function ConflictingTimesIcon({ item, changeItemDates, previousItem, nextItem }: Props) {
  const openModal = useOpenModal()

  const updateItemOrTripDates = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      openModal(OverlappingTimesModal, {
        item,
        previousItem,
        nextItem,
        changeItemDates,
      })
      e.stopPropagation()
    },
    [changeItemDates, item, previousItem, nextItem, openModal],
  )

  return (
    <Tooltip description="Click here to view time conflict">
      <FlexClickable onClick={updateItemOrTripDates}>
        <SolidExclamationTriangleIcon size="XS" colour="warning" />
      </FlexClickable>
    </Tooltip>
  )
}

export default ConflictingTimesIcon
